<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 09:43:37
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-05 12:00:51
 * @Description: 财务报告 2018
 -->
<template>
  <div class="financial-reports-2018">
    <img :src="item" alt="" srcset="" v-for="(item, index) in imgList" :key="index" />
  </div>
</template>
<script>
export default {
  name: 'financial-reports-2018',
  computed: {
    imgList() {
      let arr = [];
      for (let i = 1; i < 20; i++) {
        const index = i < 10 ? `0${i}` : i;
        arr.push(`https://files.jinr.com/jinr-index/financial-reports/2018/${index}.png`);
      }
      return arr;
    }
  }
};
</script>
<style lang="less">
.financial-reports-2018 {
  img {
    width: 160%;
    transform: translateX(-25%);
  }
}
</style>
